import { pickUserImage } from "../../utils/userIdentity";

/** Resolve a readable dealer name from auth state / API shape. */
export function getDealerDisplayName(auth = {}) {
  const user = auth.user || {};
  const first =
    auth.firstname ||
    auth.first_name ||
    user.firstname ||
    user.first_name ||
    "";
  const last =
    auth.lastname ||
    auth.last_name ||
    user.lastname ||
    user.last_name ||
    "";
  const full = `${first} ${last}`.trim();
  return (
    full ||
    auth.username ||
    user.username ||
    auth.email ||
    user.email ||
    "Dealer"
  );
}

export function getDealerInitials(auth = {}) {
  const name = getDealerDisplayName(auth);
  if (!name || name === "Dealer") return "D";
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

/** Profile photo URL for dealers UI (falls back to empty string). */
export function getDealerAvatarUrl(auth = {}) {
  const user = auth.user || {};
  return pickUserImage(auth, user) || "";
}
